import React from "react";
import { Clear } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { baseColors } from "../theme";
import { baseColorsByTheme } from "../theme/baseColors";

interface ClearCrossButtonProps {
    handleClear: (data: any) => void;
}

const ClearCrossButton = ({ handleClear }: ClearCrossButtonProps) => {
    return (
        <IconButton
            sx={{
                backgroundColor: baseColors.grey35,
                color: "white",
                width: "20px",
                height: "20px",
                "&:hover": {
                    backgroundColor: baseColorsByTheme().primary,
                },
            }}
            onClick={handleClear}
            tabIndex={-1}
        >
            <Clear></Clear>
        </IconButton>
    );
};

export default ClearCrossButton;
